module.exports = __webpack_public_path__ + "media/images/emblems/St_Moritz_wappen-436b77e924cba1908c2bd5a9c58d984d.svg";